<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>

      <div class="clause">
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          授 权 书
        </p>
        <p style=" font-size: 16px;text-align:left">致公司：</p>
        <p class="distance">
          鉴于本公司拟通过贵司开展相关业务（“<span
            style="color: #000;font-weight:bold"
            >拟开展业务</span
          >”）。就贵司为拟开展业务之目的采集、处理和使用本公司信息，本公司特此作出如下授权和承诺：
        </p>
        <p class="distance_50" style="color: #000;font-weight:bold">
          一、授权范围
        </p>
        <p class="distance_80">
          本公司同意并无条件、不可撤销地授权：
        </p>
        <p class="distance_80">
          （一）贵司以及与贵司建立合法合作关系的第三方机构（包括有合法权限从事拟开展业务及本授权书项下信用数据处理业务的机构）有权按照适用法律的规定为下述第二款载明之目的（“<span
            style="color: #000;font-weight:bold"
            >使用目的</span>”）采集、处理和使用本公司的工商信息、信用信息及/或涉税信息（包含但不限于发票数据）（“<span
            style="color: #000;font-weight:bold"
            >信用数据</span>”）。
        </p>
        <p class="distance_80">
          （二）贵司对本公司信用数据的采集、处理和使用应仅为拟开展业务所需，用于下述目的：
        </p>
         <p class="distance_80">
          （1）审核本公司的相关申请并进行相关风险评估和风险控制；
        </p>         <p class="distance_80">
          （2）审核本公司如下人员之情况，包括但不限于：负责人、法定代表人、出资人、担保人、企业经营者、实际控制人；
        </p>
        <p class="distance_80">
          （3）与本公司拟开展业务相关的经营风险管理。
        </p>
        <p class="distance_50" style="color: #000;font-weight:bold">
          二、信息使用
        </p>
        <p class="distance_80">
          基于前述使用目的，本公司明确知悉并同意贵司可自行或委托第三方机构按照法律规定对本公司资信情况进行分析。
        </p>
        <p class="distance_50" style="color: #000;font-weight:bold">
         三、其他事项
        </p>
        <p class="distance_80">
         （一）若贵司超出本授权书的范围违法查询和使用本公司的信用数据，贵司应承担相应的法律责任。
        </p>
        <p class="distance_80">
         （二）本授权书、本公司信用数据及/或信用评估报告无须销毁或退回本公司。贵司有权继续存储和保留本公司信用数据及/或信用评估报告，并有权在任何第三方均无法识别或还原信用数据与本公司的联系的情况下，或为了该等目的，对信用数据进行处理和使用。
        </p>
        <p class="distance_50" style="color: #000;font-weight:bold">
          本公司知悉和完全理解本授权书的内容，本授权书下的授权是本公司法定代表人代表本公司作出的真实意思表示，本公司愿意承担相应的法律责任。
        </p>
        <div style="text-align:left">
          <p>法定代表人（签字）</p>
          <p>授权日期：年月日</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: "微软雅黑";
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 6px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
